import { apiPost, API_ENDPOINTS } from "../utils/apiUtils";

/**
 * Notification Service
 * Handles notification operations
 */
const NotificationService = {
  /**
   * Send notification
   * @param {Object} notificationData - Notification data
   * @returns {Promise} API response
   */
  async sendNotification(notificationData) {
    return apiPost(API_ENDPOINTS.NOTIFICATIONS.SEND, notificationData);
  },
};

export default NotificationService; 